
import {
    AlertDialog,
    AlertDialogBody, AlertDialogContent, AlertDialogFooter,
    AlertDialogHeader, AlertDialogOverlay,
    Button
} from '@chakra-ui/react';

function DeleteForm(props) {

return (
<AlertDialog
        isOpen={props.isOpen}
        onClose={props.onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Elimina esercizio
            </AlertDialogHeader>

            <AlertDialogBody>
             {props.alertText}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={props.onClose}>
                Indietro
              </Button>
              <Button colorScheme='red' onClick={props.onDelete} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );

}

export default DeleteForm;